<template>
  <div v-if="!isLoading" class="container-fluid new_Header">
    
  </div>
  <div class="container">
    <div v-if="isLoading || loader" class="text-center">
      <mainloader />
    </div>
    <div v-else class="row">
      <div class="col">
        <div class="row">
          <div v-if="hasError" class="text-center">
            <errorAlert :alertMessage="message" /> 
          </div>
          <div class="col" v-if="form == 1">
            <div class="row">
              <div class="col">
                <!-- <span class="mouse-hand" @click.prevent="prevStep">
                  <i class="fa-solid fa-arrow-right"></i>
                </span> -->
                <h5 class="font-24 almarai-bold py-2">{{$t('propertieupdate.title_1')}}</h5>
              </div>
            </div>
            <div class="row pt-3">
              <div class="col">
                <div class="mb-3">
                  <input class="form-check-input" v-model="ownerType" type="radio" name="radioDefault" id="ownerType-1" value="owner">
                  <label class="form-check-label mx-2" for="ownerType-1">{{$t('propertieupdate.title_2')}}</label>
                </div>
                <div class="mb-3">
                  <input class="form-check-input" v-model="ownerType" type="radio" name="radioDefault" id="ownerType-2" value="agent">
                  <label class="form-check-label mx-2" for="ownerType-2">{{$t('propertieupdate.title_3')}}</label>
                </div>
                <div class="mb-3">
                  <input class="form-check-input" v-model="ownerType" type="radio" name="radioDefault" id="ownerType-3" value="broker">
                  <label class="form-check-label mx-2" for="ownerType-3">{{$t('propertieupdate.title_4')}}</label>
                </div>
              </div>
            </div>
            <div class="row pt-5 justify-content-center">
              <div class="col-11 col-md-4">
                <div @click.prevent="nextStep" class="orange-btn">
                  {{$t('next')}}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--begin:add Real Estate-->
        <div v-if="form == 2" class="row justify-content-center">
          <div class="col">
            <div class="row">
              <div class="col">
                <span class="mouse-hand" @click.prevent="prevStep"> 
                  <i v-if="userLang == 'ar'" class="fa-solid fa-arrow-right"></i>
                  <i v-else class="fa-solid fa-arrow-left"></i>
                </span>
                <div>
                  <h5 class="py-2 font-24 almarai-bold">{{$t('propertieupdate.title_5')}}</h5>
                </div>
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-12 col-md-6">
                <div class="card input-style bg-card">
                  <div class="card-body p-1">
                    <div class="row">
                      <div class="col text-center" @click.prevent="ownerFN">
                        <div :class="(ownerType == 'owner') ? 'form-control input-style bg-button bg-shadow': 'form-control input-style bg-button'" >مالك</div>
                      </div>
                      <div class="col text-center" @click.prevent="agentFN">
                        <div :class="(ownerType == 'agent') ? 'form-control input-style bg-button bg-shadow ': 'form-control input-style bg-button'">وكيل</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
          <div class="row py-3 justify-content-center">
            <div class="col">
              <!-- begin:form owner -->
              <div class="row" v-if="ownerType == 'owner'">
                <div class="col-12 col-md-6 pb-2">
                  <label for="" class="p-content" >{{$t('propertieupdate.title_6')}}</label>
                  <input type="file" class="form-control input-style" @change="uploadFile($event.target.files)" multiple>
                </div>
                <div class="col-12">
                  <div class="row">
                    <div class="col-auto" v-for="(img, indx) in receiptImages" :key="indx">
                      <a v-if="img.extention == 'pdf'" :href="MEDIA_URL+img.path" target="_blank">PDF file</a>
                      <img v-if="img.extention != 'pdf'" :src="MEDIA_URL+img.path" class="max-80" alt="">
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6 pb-2">
                  <label class="p-content" for="">{{$t('propertieupdate.title_7')}}</label>
                  <input type="text" class="form-control input-style" v-model="receiptNumber" >
                </div>
                <!-- <div class="col-12 col-md-6 pb-2">
                  <label class="p-content" for="">{{$t('propertieupdate.title_8')}}</label>
                  <input type="date" class="form-control input-style" v-model="receiptDate">
                </div> -->
                <div class="col-12 col-md-6 pb-2">
                  <label class="p-content" for="">{{$t('propertieupdate.title_9')}}</label>
                  <input type="number" class="form-control input-style" v-model="baiscOwner.ownerIdentity" >
                  <div class="error-feedback red-color fonttext-14" v-if="V$.baiscOwner.ownerIdentity.$error">
                    {{ validateMessage }}
                  </div>
                </div>
                <div class="col-12 col-md-6 pb-2">
                  <label class="p-content" for="">{{$t('propertieupdate.title_10')}}</label>
                  <input type="date" class="form-control input-style" v-model="baiscOwner.ownerDOB">
                  <div class="error-feedback red-color fonttext-14" v-if="V$.baiscOwner.ownerDOB.$error">
                    {{ validateMessage }}
                  </div>
                </div>
                <div class="col-12 col-md-6 pb-2" id="ownerMobile">
                  <label class="p-content" for="">{{$t('propertieupdate.title_11')}}</label>
                  <input type="text" class="form-control input-style" v-model="baiscOwner.ownerPhone">
                  <div class="error-feedback red-color fonttext-14" v-if="V$.baiscOwner.ownerPhone.$error">
                    {{ validateMessage }}
                  </div>
                </div>
              </div>
              <!--end:form owner -->

              <!--begin:form agent-->
              <div class="row" v-if="ownerType == 'agent'">
                <div class="col">
                  <div class="row">
                    <div class="col-12 col-md-6 pb-2">
                      <label for="" class="p-content" >{{$t('propertieupdate.agencyPhoto')}}</label>
                      <input type="file" class="form-control input-style" @change="uploadAgencyFile($event.target.files)"  multiple>
                    </div>
                    <div class="col-12">
                      <div class="row">
                        <div class="col-auto" v-for="(g, indxe) in agencyImage" :key="indxe">
                          <a v-if="g.extention == 'pdf'" :href="MEDIA_URL+g.path" target="_blank">PDF file</a>
                          <img v-if="g.extention != 'pdf'" :src="MEDIA_URL+g.path" class="max-80" alt="">
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 pb-2">
                      <label class="p-content" for="">{{$t('propertieupdate.title_7')}}</label>
                      <input type="text" class="form-control input-style" v-model="receiptNumber" >
                    </div>
                    <!-- <div class="col-12 col-md-6 pb-2">
                      <label class="p-content" for="">{{$t('propertieupdate.title_8')}}</label>
                      <input type="text" class="form-control input-style" v-model="receiptDate">
                    </div> -->
                    <!-- <div class="col-12 col-md-6 pb-2">
                      <label class="p-content" for="">{{$t('propertieupdate.title_9')}}</label>
                      <input type="number" class="form-control input-style" v-model="baiscAgent.ownerIdentity" >
                      <div class="error-feedback red-color fonttext-14" v-if="V$.baiscAgent.ownerIdentity.$error">
                        {{ validateMessage }}
                      </div>
                    </div> -->
                    <!-- <div class="col-12 col-md-6 pb-2">
                      <label class="p-content" for="">{{$t('propertieupdate.title_10')}}</label>
                      <input type="text" class="form-control input-style" v-model="baiscAgent.ownerDOB">
                      <div class="error-feedback red-color fonttext-14" v-if="V$.baiscAgent.ownerDOB.$error">
                        {{ validateMessage }}
                      </div>
                    </div> -->
                    <div class="col-12 col-md-6 pb-2">
                      <label class="p-content" for="">{{$t('propertieupdate.title_12')}}</label>
                      <input type="number" class="form-control input-style" v-model="baiscAgent.agentIdentity">
                      <div class="error-feedback red-color fonttext-14" v-if="V$.baiscAgent.agentIdentity.$error">
                        {{ validateMessage }}
                      </div>
                    </div>
                    <div class="col-12 col-md-6 pb-2">
                      <label class="p-content" for="">{{$t('propertieupdate.title_13')}}</label>
                      <input type="text" class="form-control input-style" v-model="baiscAgent.agencyNumber">
                      <div class="error-feedback red-color fonttext-14" v-if="V$.baiscAgent.agencyNumber.$error">
                        {{ validateMessage }}
                      </div>
                    </div>
                    <!-- <div class="col-12 col-md-6 pb-2">
                      <label class="p-content" for="">{{$t('propertieupdate.title_14')}} </label>
                      <input type="text" class="form-control input-style" v-model="agencyDate">
                    </div> -->
                    <!-- <div class="col-12 col-md-6 pb-2">
                      <label class="p-content" for="">{{$t('propertieupdate.title_15')}}</label>
                      <input type="text" class="form-control input-style " v-model="baiscAgent.agentDOB">
                      <div class="error-feedback red-color fonttext-14" v-if="V$.baiscAgent.agentDOB.$error">
                        {{ validateMessage }}
                      </div>
                    </div> -->
                  </div>
                  <div class="row">
                    <div class="col-12 col-md-6 pb-2">
                      <label class="p-content" for="">{{$t('propertieupdate.title_16')}}</label>
                      <input type="text" class="form-control input-style" v-model="baiscAgent.agentMobile">
                      <div class="error-feedback red-color fonttext-14" v-if="V$.baiscAgent.agentMobile.$error">
                        {{ validateMessage }}
                      </div>
                    </div>
                    <div class="col-12 col-md-6 pb-2">
                    </div>
                  </div>
                </div>
              </div>
              <!--end:form agent-->


              <!--begin:broker Advertisement-->
              <div class="row justify-content-center" v-if="ownerType == 'broker'">
                <div class="col-12">
                  <div class="row">
                    <div class="col-12 col-md-6 pb-2">
                      <label for="" class="p-content" >{{$t('propertieupdate.title_6')}}</label>
                      <input type="file" class="form-control input-style" @change="uploadFile($event.target.files)" multiple>
                    </div>
                    <div class="col-12">
                      <div class="row">
                        <div class="col-auto" v-for="(img, indx) in receiptImages" :key="indx">
                          <a v-if="img.extention == 'pdf'" :href="MEDIA_URL+img.path" target="_blank">PDF file</a>
                          <img v-if="img.extention != 'pdf'" :src="MEDIA_URL+img.path" class="max-80" alt="">
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 pb-2 mb-3">
                      <label for="" class="p-content"  >{{$t('propertieupdate.title_18')}}</label>
                      <input type="text" v-model="broker.falLicense" class="form-control input-style" placeholder="أدخل رقم رخصة فال">
                      <div class="error-feedback red-color fonttext-14" v-if="V$.broker.falLicense.$error">
                        {{ validateMessage }}
                      </div>
                    </div>
                    <div class="col-12 col-md-6 pb-2 mb-3">
                      <label for="" class="p-content" >{{$t('propertieupdate.title_19')}}</label>
                      <input type="text" v-model="broker.adLicenseNumber" class="form-control input-style" placeholder="أدخل رقم الصك">
                      <div class="error-feedback red-color fonttext-14" v-if="V$.broker.adLicenseNumber.$error">
                        {{ validateMessage }}
                      </div>
                    </div>
                    <div class="col-12 col-md-6 pb-2 mb-3">
                      <label for="" class="p-content" >{{$t('propertieupdate.title_7')}}</label>
                      <input type="text" v-model="receiptNumber" class="form-control input-style" placeholder="أدخل رقم الصك">
                    </div>
                    <!-- <div class="col-12 col-md-6 pb-2 mb-3">
                      <label for="" class="p-content" >{{$t('propertieupdate.title_8')}}</label>
                      <input type="date" v-model="receiptDate" class="form-control input-style" placeholder="أدخل تاريخ الصك">
                    </div> -->
                    <!-- <div class="col-12 col-md-6 pb-2 mb-3">
                      <label for="" class="p-content" >{{$t('propertieupdate.title_10')}}</label>
                      <input type="date" v-model="broker.ownerDOB" class="form-control input-style" placeholder="أدخل تاريخ ميلاد المالك">
                      <div class="error-feedback red-color fonttext-14" v-if="V$.broker.ownerDOB.$error">
                        {{ validateMessage }}
                      </div>
                    </div> -->
                    <!-- <div class="col-12 col-md-6 pb-2 mb-3">
                      <label for="" class="p-content" >{{$t('propertieupdate.title_11')}}</label>
                      <input type="text" v-model="broker.ownerPhone" class="form-control input-style" placeholder="أدخل رقم جوال المالك">
                      <div class="error-feedback red-color fonttext-14" v-if="V$.broker.ownerPhone.$error">
                        {{ validateMessage }}
                      </div>
                    </div> -->
                    <!-- <div class="col-12 col-md-6 pb-2 mb-3">
                      <label for="" class="p-content" >{{$t('propertieupdate.title_12')}}</label>
                      <input type="number" v-model="broker.agentIdentity" class="form-control input-style" placeholder="أدخل رقم هوية الوكيل">
                      <div class="error-feedback red-color fonttext-14" v-if="V$.broker.agentIdentity.$error">
                        {{ validateMessage }}
                      </div>
                    </div> -->
                    <!-- <div class="col-12 col-md-6 pb-2 mb-3">
                      <label for="" class="p-content"> {{$t('propertieupdate.title_13')}}</label>
                      <input type="text" v-model="broker.agencyNumber" class="form-control input-style" placeholder="أدخل رقم الوكالة">
                      <div class="error-feedback red-color fonttext-14" v-if="V$.broker.agencyNumber.$error">
                        {{ validateMessage }}
                      </div>
                    </div> -->
                    <!-- <div class="col-12 col-md-6 pb-2 mb-3">
                      <label for="" class="p-content">{{$t('propertieupdate.title_15')}}</label>
                      <input type="date" v-model="broker.agentDOB" class="form-control input-style" placeholder="أدخل تاريخ ميلاد الوكيل">
                      <div class="error-feedback red-color fonttext-14" v-if="V$.broker.agentDOB.$error">
                        {{ validateMessage }}
                      </div>
                    </div> -->
                    <div class="col-12 col-md-6 pb-2 mb-3">
                      <label for="" class="p-content">{{$t('propertieupdate.title_16')}}</label>
                      <input type="text" v-model="broker.agentMobile" class="form-control input-style" placeholder="أدخل جوال الوكيل">
                      <div class="error-feedback red-color fonttext-14" v-if="V$.broker.agentMobile.$error">
                        {{ validateMessage }}
                      </div>
                    </div>
                    <div class="col-12 col-md-6"></div>
                  </div>
                </div>
              </div>
              <!--end: broker Advertisement -->
              <div class="row pt-5 justify-content-center">
                <div class="col-11 col-md-4">
                  <div @click.prevent="nextStep" class="btn-black" >{{$t('next')}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end:add Real Estate-->


        <!--begin: Property documentation-->
        <div class="row d-none">
          <div class="col">
            <div class="row">
              <div class="col">
                <span class="mouse-hand" @click.prevent="prevDocument"> 
                  <i v-if="userLang == 'ar'" class="fa-solid fa-arrow-right"></i>
                  <i v-else class="fa-solid fa-arrow-left"></i>
                </span>
                <div>
                  <h5 class="py-2 font-24 almarai-bold">{{$t('propertieupdate.title_20')}}</h5>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-8 pb-2 mb-3">
                <label for="" class="p-content" >{{$t('propertieupdate.title_21')}}</label>
                <input type="text" class="form-control input-style" :placeholder="$t('propertieupdate.title_23')">
              </div>
              <div class="col-12 col-md-8 pb-2 mb-3">
                <label for="" class="p-content">{{$t('propertieupdate.title_22')}}</label>
                <input type="text" class="form-control input-style" placeholder="أدخل رقم الجوال">
              </div>
            </div>
            <div class="row pt-5 justify-content-center">
              <div class="col-12 col-md-8">
                <button class="login-btn rounded-pill form-control almarai-bold" >التالي</button>
              </div>
            </div>
          </div>
        </div>
        <!--end: Property documentation-->
        
        <!--begin:Property Data Add-->
        <div v-if="form == 3" class="row">
          <div class="col">
            <div class="row">
              <div class="col">
                <span class="mouse-hand" @click.prevent="prevStep">
                  <i v-if="userLang == 'ar'" class="fa-solid fa-arrow-right"></i>
                  <i v-else class="fa-solid fa-arrow-left"></i>
                </span>
                <div class="py-2">
                  <h5>{{$t('propertieupdate.title_25')}}</h5>
                </div>
              </div>
            </div>
            <div class="row py-2">
              <span class="p-content py-2">{{$t('propertieupdate.title_26')}}</span>
              <div class="col-auto">
                <label class="form-check-label mouse-hand" for="flexRadio">
                  <div :class="(propertyAdd.category == 'commercial')? 'form-check rounded-pill classification-b button-bg':'form-check rounded-pill classification-b'">
                    <input type="radio" class="form-check-input d-none" required v-model="propertyAdd.category" value="commercial" id="flexRadio" name="flexn">
                    <span>{{$t('propertieupdate.title_27')}}</span>
                  </div>
                </label>
              </div>
              <div class="col-auto mouse-hand mt-2">
                <label class="form-check-label mouse-hand" for="flexRadioDefault2">
                  <div :class="(propertyAdd.category == 'residential')? 'form-check rounded-pill classification-b button-bg': 'form-check rounded-pill classification-b'">
                    <input class="form-check-input d-none" type="radio" v-model="propertyAdd.category" value="residential" name="flexn" id="flexRadioDefault2">
                    {{$t('propertieupdate.title_28')}}
                  </div>
                </label>
              </div>
              <div class="error-feedback red-color fonttext-14" v-if="V$.propertyAdd.category.$error">
                {{ validateMessage }}
              </div>
            </div>
            <div class="row py-2">
              <div class="col-12 col-md-6 pb-2">
                <label class="p-content" for="">{{$t('propertieupdate.title_29')}}</label>
                <select v-model="propertyAdd.purpose" name="" class="form-select select-style">
                  <option value="for_sale">{{$t('propertieupdate.title_30')}}</option>
                  <option value="for_rent">{{$t('propertieupdate.title_31')}}</option>
                  <option value="for_investment">{{$t('propertieupdate.title_32')}}</option>
                </select>
                <div class="error-feedback red-color fonttext-14" v-if="V$.propertyAdd.purpose.$error">
                  {{ validateMessage }}
                </div>
              </div>
              <div class="col-12 col-md-6 pb-2">
                <label class="p-content" for="">{{$t('propertieupdate.title_33')}}</label>
                <select v-model="propertyAdd.typeId" class="form-select select-style">
                  <option  v-for="(type,index) in types" :key="index"  :value="type.id">{{type.name}}</option>
                </select>
                <div class="error-feedback red-color fonttext-14" v-if="V$.propertyAdd.typeId.$error">
                  {{ validateMessage }}
                </div>
              </div>
              <div class="col-12 col-md-6 pb-2">
                <label class="p-content" for="">{{$t('propertieupdate.title_34')}}</label>
                <select v-model="propertyAdd.propertyType" name="" class="form-select select-style">
                  <option value="families">{{$t('propertieupdate.title_35')}}</option>
                  <option value="singles">{{$t('propertieupdate.title_36')}}</option>
                </select>
                <div class="error-feedback red-color fonttext-14" v-if="V$.propertyAdd.propertyType.$error">
                  {{ validateMessage }}
                </div>
              </div>
              <div class="col-12 col-md-6 pb-2">
                <label class="p-content" for="">{{$t('propertieupdate.title_37')}}</label>
                <input type="text" v-model="propertyAdd.title" class="form-control select-style">
                <div class="error-feedback red-color fonttext-14" v-if="V$.propertyAdd.title.$error">
                  {{ validateMessage }}
                </div>
              </div>
            </div>
            <div class="row py-2">
              <div class="col-12 col-md-6 pb-2">
                <label class="p-content"  for="">{{$t('propertieupdate.title_38')}}</label>
                <textarea id="des" v-model="propertyAdd.description" class="form-control" rows="2"></textarea>
                <div class="error-feedback red-color fonttext-14" v-if="V$.propertyAdd.description.$error">
                  {{ validateMessage }}
                </div>
              </div>
              <div class="col-12 col-md-6 pb-2">
                <label class="p-content" for="">{{$t('propertieupdate.title_39')}}</label>
                <input type="number"  v-model="price" class="form-control select-style">
              </div>
              <div class="col-12 pb-2">
                <label class="p-content" for="">{{$t('propertieupdate.title_40')}}</label>
                <input type="file" v-if="!mediaLoader" class="form-control select-style" @change="uploadMedia($event.target.files)" multiple>
                <!--begin mediaLoader-->
                <div v-if="mediaLoader" class="text-center"><loader /></div>
                <!--end mediaLoader-->
                <div class="row">
                  <div class="col-auto my-2"  v-for="(img, indx) in mediaList" :key="indx">
                    <div class="position-R" @click.prevent="deleteImg(img.id, indx)" >
                      <i class="bi bi-trash delete-icon red-color mouse-hand"></i>
                    </div>
                    <img :src="MEDIA_URL+img.thumbnail" style="max-width: 160px;" alt="">
                  </div>
                </div>
              </div>
            </div>
            <div class="row py-2">
              <div class="col-12 col-md-6 pb-2">
                <label class="p-content" for="">{{$t('propertieupdate.title_41')}}</label>
                <select  v-model="propertyAdd.regionId" class="form-select select-style">
                  <option v-for="(region,index) in regions" :key="index" :value="region.id">{{ region.name }}</option>
                </select>
                <div class="error-feedback red-color fonttext-14" v-if="V$.propertyAdd.regionId.$error">
                  {{ validateMessage }}
                </div>
              </div>
              <div class="col-12 col-md-6 pb-2">
                <label for="" class="p-content">{{$t('propertieupdate.title_42')}}</label>
                <select v-model="propertyAdd.cityId" class="form-select select-style" >
                  <option v-for="(city,index) in cities" :key="index" :value="city.id"> {{ city.name }}</option>
                </select>
                <div class="error-feedback red-color fonttext-14" v-if="V$.propertyAdd.cityId.$error">
                  {{ validateMessage }}
                </div>
              </div>
              <div class="col-12 col-md-6 pb-2">
                <label for="" class="p-content">{{$t('propertieupdate.title_43')}}</label>
                <select v-model="propertyAdd.neighborhoodId" class="form-select select-style" >
                  <option v-for="(row,index) in rows" :key="index" :value="row.id">{{ row.name }}</option>
                </select>
                <div class="error-feedback red-color fonttext-14" v-if="V$.propertyAdd.neighborhoodId.$error">
                  {{ validateMessage }}
                </div>
              </div>
              <div class="col-12 col-md-6 pb-2">
                <label for="" class="p-content">{{$t('propertieupdate.title_44')}}</label>
                <input type="text" v-model="street" class="form-control">
              </div>
              <div  class="col-12 col-md-6 pb-2">
                <label for="" class="p-content">{{$t('propertieupdate.title_45')}}</label>
                <input type="text" v-model="buildNumber" class="form-control">
              </div>
              <div  class="col-12 col-md-6 pb-2">
                <label for="" class="p-content">{{$t('propertieupdate.title_46')}}</label>
                <input type="number" v-model="floorNumber" class="form-control">
              </div>
              <div class="col-12 col-md-6 pb-2">
                <label class="p-content" for="">{{$t('propertieupdate.title_47')}}</label>
                <input type="number" class="form-control select-style" v-model="floorsCount">
              </div>
              <div  class="col-12 col-md-6 pb-2">
                <label for="" class="p-content">{{$t('propertieupdate.title_48')}}</label>
                <input type="number" v-model="apartmentNumber" class="form-control">
              </div>
              <div  class="col-12 col-md-6 pb-2">
                <label for="" class="p-content">{{$t('propertieupdate.title_49')}}</label>
                <input type="number" v-model="age" class="form-control">
              </div>
              <div class="col-12 col-md-6 pb-2">
                <label class="p-content" for="">{{$t('propertieupdate.title_50')}}</label>
                <input type="number" class="form-control select-style" v-model="propertyAdd.area">
                <div class="error-feedback red-color fonttext-14" v-if="V$.propertyAdd.area.$error">
                  {{ validateMessage }}
                </div>
              </div>
              
              <div class="col-12 col-md-6 pb-2">
                <label class="p-content" for="">{{$t('propertieupdate.title_51')}}</label>
                <input type="number" class="form-control select-style" v-model="roomsCount">
              </div>
              <div class="col-12 col-md-6 pb-2">
                <label class="p-content" for="">{{$t('propertieupdate.title_52')}}</label>
                <input type="number" class="form-control select-style" v-model="bathrooms">
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="almarai-bold py-2">{{$t('propertieupdate.title_53')}}</div>
                <div ref="myMap" style="width: 100%; height: 320px;"></div>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-md-6 pb-2">
                <label class="p-content" for="">{{$t('propertieupdate.title_54')}}</label>
                <input type="number" class="form-control select-style" v-model="longitude">
              </div>
              <div class="col-12 col-md-6 pb-2">
                <label class="p-content" for="">{{$t('propertieupdate.title_55')}}</label>
                <input type="number" class="form-control select-style" v-model="latitude">
              </div>
            </div>

            <div class="row py-2">
              <div class="col-auto">
                <button type="button" class="btn btn-background br-radius" data-bs-toggle="modal" data-bs-target="#exampleModal">
                  <i class="bi bi-file-earmark-plus"></i>
                  <span class="mx-2">{{$t('propertieupdate.title_56')}}</span>
                </button>
              </div>
            </div>
            <div class="row pt-5 justify-content-center">
              <div class="col-12 col-md-5">
                <div @click.prevent="nextStep" class="form-control orange-btn">
                  {{$t('next')}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end: Property Data Add-->

        <!--begin: Advertisement details-->
        <div v-if="form == 4" class="row">
          <div class="col">
            <div class="text-center" v-if="AdvertisementError">
              <errorAlert :alertMessage="message" :errorNumber="errorNumber"/>
            </div>
            <div class="row">
              <div class="col">
                <span @click.prevent="prevStep" class="mouse-hand">
                  <i v-if="userLang == 'ar'" class="fa-solid fa-arrow-right"></i>
                  <i v-else class="fa-solid fa-arrow-left"></i>
                </span>
                <div class="py-2">
                  <h5 class="font-24 almarai-bold" >{{$t('propertieupdate.title_57')}}</h5>
                </div>
              </div>
            </div>
            <div class="row py-2">
              <!-- <div class="col-12 col-md-6 mb-3">
                <label class="p-content" for="">مدة الاعلان</label>
                <select name="" v-model="aD_duration.durations" class="form-select select-style">
                  <option v-for="(duration,index) in durations" :key="index" :value="duration.val">
                    {{ duration.label }}
                  </option>
                </select>
                <div class="error-feedback red-color fonttext-14" v-if="V$.aD_duration.durations.$error">
                  {{ validateMessage }}
                </div>
              </div> -->
              <div class="col-12 col-md-6 button-center">
                <input type="checkbox" v-model="isFeatured" id="featuredOne" value="true" class="form-check-input" >
                <label class="p-content mx-3" for="featuredOne">{{$t('propertieupdate.title_58')}}</label>
              </div>
            </div>

            <div class="row pt-5 justify-content-center">
              <div class="col-12 col-md-5">
                <div class="text-center" v-if="mLoader">
                  <loader />
                </div>
                <button v-else @click.prevent="submitUpdate" class="form-control orange-btn">
                  {{$t('propertieupdate.title_59')}}
                </button>
              </div>
            </div>
          </div>
        </div>
        <!--end: Advertisement details-->

      </div>
    </div>
    

    <!--begin: Payment of fees-->
    <!-- <div class="row d-none">
      <div class="col">
        <div class="row">
          <div class="col">
            <span class="mouse-hand" @click.prevent="prevFour">
              <i class="fa-solid fa-arrow-right"></i>
            </span>
            <div class="py-2">
              <h5 class="almarai-bold ">دفع الرسوم</h5>
            </div>
            <div class="p-content">سعر لاعلان لمدة شهر (ترخيصك الاعلاني مجانا)</div>
            <div class="py-2">
              <h4 class="almarai-bold ">50 ريال فقط!</h4>
            </div>
          </div>
        </div>

        <div class="row py-2">
          <div class="col">
            <label class="p-content" for="">كود الخصم</label>
            <input type="text" class="form-control input-style" placeholder="ارفق كود خصم الخاص بك">
          </div>
        </div>

        <div class="row py-2">
          <div class="col-6 col-md-6">
            <div class="almarai-bold ">اختر طريقة الدفع</div>
          </div>
          <div class="col-6 col-md-6 text-start">
            <div class="orange-font">
              <i class="fa-solid fa-plus"></i>
              <span class="mx-2">اضافةبطاقة جديدة</span>
            </div>
          </div>
        </div>

        <div class="row py-2">
          <div class="col">
            <div class="form-check mb-2 input-style position-R">
              <input class="form-check-input check-radio" name="flexRadioDefault" id="mmm" type="radio" >
              <label class="form-check-label w-100" for="mmm" >
                <img src="/assets/images/empty-wallet.png" alt=""> 
                <span class="mx-2">المحفظة (1300 ريال)</span>
              </label>
            </div>
            <div class="form-check mb-2 input-style position-R">
              <input class="form-check-input check-radio" type="radio" id="flexRadioDefault1" name="flexRadioDefault" >
              <label class="form-check-label w-100" for="flexRadioDefault1" >
              <img src="/assets/images/Frame 39.png" alt="">
              <span class="mx-2"> أبل باي</span>
              </label>
            </div>
            <div class="form-check input-style position-R mb-2">
              <input class="form-check-input check-radio" id="stc" type="radio" name="flexRadioDefault" >
              <label class="form-check-label w-100" for="stc" >
                <img src="/assets/images/Frame_40.png" alt=""> 
                <span class="mx-2">أس تي سي باي</span>
              </label>
            </div>
            <div class="form-check input-style position-R mb-2">
              <input class="form-check-input check-radio" id="visa" type="radio" name="flexRadioDefault" >
              <label class="form-check-label w-100" for="visa" >
                <img src="/assets/images/Frame_41.png" alt=""> 
                <span class="mx-2">1413_***_***_***</span>
              </label>
            </div>
            <div class="form-check input-style position-R mb-2">
              <input class="form-check-input check-radio" id="mada" type="radio" name="flexRadioDefault">
              <label class="form-check-label w-100" for="mada" >
                <img src="/assets/images/Frame_42.png" alt=""> 
                <span class="mx-2">1413_***_***_***</span>
              </label>
            </div>
            <div class="form-check input-style position-R mb-2">
              <input class="form-check-input check-radio" id="flexRadio" type="radio" name="flexRadioDefault" >
              <label class="form-check-label w-100" for="flexRadio">
                <img src="/assets/images/Frame_43.png" alt=""> 
                <span class="mx-2">1413_***_***_***</span>
              </label>
            </div>
          </div>
        </div>

        <div class="row py-2 justify-content-center mt-5">
          <div class="col-12 col-md-8">
            <div class="row justify-content-center">
              <div class="col-12 col-md-8">
                <button @click.prevent="stepFive" class="form-control buttonStyle rounded-pill">
                  التالي
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!--end: Payment of fees-->

    <!--begin:form success-->
    <div v-if="form == 5" class="row">
      <div class="col">
        <div class="row">
          <div class="col text-center">
            <div><img src="/assets/images/tick-circle.png" class="img-fluid" alt=""></div>
          </div>
        </div>
        <div class="row pt-4">
          <div class="col text-center">
            <h4 class="almarai-bold">{{$t('formSuccess.title_1')}}</h4>
          </div>
        </div>
        <div class="row pt-2">
          <div class="col text-center">
            <span class="p-content">{{$t('formSuccess.title_2')}}</span> <br>
            <span class="p-content">{{$t('formSuccess.title_3')}}</span>
          </div>
        </div>

        <div class="row py-4 justify-content-center">
          <div class="col-12 col-md-5">
            <router-link to="/">
              <button class="btn-black form-control">{{$t('formSuccess.title_4')}}</button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!--end:form success-->

    <!-- Modal -->
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog max-w">
        <div class="modal-content">
          <button type="button" class="btn-close p-3" @click="restValue" data-bs-dismiss="modal" aria-label="Close"></button>
          <div class="modal-body">
            <!--begin:Property Features-->
            <div class="row pt-3" v-for="(feature ,index) in featuresList" :key="index">
              <div class="almarai-bold mb-2"> {{feature.category }} </div>
              <div class="col-6 col-md-6 button-center space py-2" v-for="(feature,indx) in featuresList[index].features" :key="indx">
                <input class="form-check-input mx-2" type="checkbox" v-model="features" :value="feature.id" :id="feature.id">
                <label class="form-check-label" :for="feature.id">
                  <img :src="MEDIA_URL+feature.icon" class=" img-fluid" alt="">
                  <span class="mx-1"> {{feature.name }}</span>
                </label>
              </div>
            </div>
            <!--end: Property Features-->
          </div>
          <div class="modal-footer">
            <button type="button" class="btn ms-auto btn-background br-radius" data-bs-dismiss="modal">{{$t('propertieupdate.title_60')}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
export default {
  name: "propertieupdate",
  setup () {
    return { V$: useVuelidate() }
  },
  data(){
    return {
      hasError: false,
      AdvertisementError: false,
      errorNumber: 0,
      message: "",
      form: 1,
      ownerData: 1,
      brokerAd: "",
      ownerType: "",
      agentData: "",
      validateMessage: this.$t('validateMessage'),
      baiscOwner: { ownerIdentity: null, ownerDOB: null, ownerPhone: "" },
      baiscAgent: {
        ownerIdentity: null, ownerDOB: null, agentIdentity: null, agentDOB: null,
        agencyNumber: "", agentMobile: ""
      },
      receiptNumber: "",
      receiptDate: null,
      agencyDate: null,
      
      
      propertyAdd: {
        category: "", purpose: "", typeId: null, propertyType: "", title: "", area: null,
        description: "", regionId: null, cityId: null, neighborhoodId: null
      },

      // aD_duration: { durations: "" },

      broker: { falLicense: "", adLicenseNumber: "", ownerDOB: null, ownerPhone: "", 
        agentIdentity: null, agencyNumber: "", agentMobile: "", agentDOB: null,
      },
      price: 0,
      street: "",
      buildNumber: "",
      floorNumber: 0,
      floorsCount: 0,
      age: 0,
      apartmentNumber: 0,
      roomsCount: 0,
      bathrooms: 0,
      isFeatured: false,
      features: [],
      regions: [],
      featuresList: [],
      types: [],      
      isLoading: true,
      upReceiptImage: "",
      agencyPhoto: [],
      latitude: 0,
      longitude: 0,
      mediaList: [],
      mediaIds: [],
      mediaLoader: false,
      mLoader: false,
      cities: [],
      rows:[],
      propertyId: this.$route.params.key,
      row: {},
      loader: true,
      receiptImages:[],
      agencyImage: [],
      userLang: 'ar',
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL'])
  },
  validations () {
    return {
      baiscOwner: {
        ownerIdentity: {required}, ownerDOB: {required}, ownerPhone: {required}
      },
      baiscAgent: {
        agentIdentity: {required}, 
        agencyNumber: {required}, agentMobile: {required}
      },
      propertyAdd: {
        category: {required}, purpose: {required}, typeId: {required}, propertyType: {required},
        title: {required}, area: {required}, description: {required},  regionId: {required},
        cityId: {required}, neighborhoodId: {required}
      },

      // aD_duration: { durations: {required} },

      broker: { falLicense:{required}, adLicenseNumber: {required}, ownerDOB: {required}, 
        ownerPhone: {required}, agentIdentity: {required}, agencyNumber: {required}, 
        agentMobile: {required}, agentDOB: {required},
      },
    }
  },
  methods: {
    getDatainit(){
      this.hasError = false;
      this.$http.get("/api/properties/init").then(res => {
        // console.log(res);
        this.durations = res.data.durations;
        this.types = res.data.typesList;
        this.regions = res.data.regionsList;
        this.featuresList = res.data.featuresList;
        this.initialGoogleMap();
        this.loader = false;
      }).catch(err => {
        // console.log(err);
        this.loader = false;
        this.message = this.$globalError(err);
        this.hasError = true;
      })
    },
    
    retrieveData(){
      this.hasError = false;
      this.isLoading = true;
      this.$http.get("/api/properties/retrieve/"+this.propertyId+'?management=1').then(res => {
        // console.log(res);
        this.row = res.data;
        this.ownerType = this.row.property.PropertyOwner.ownerType;
        this.broker.adLicenseNumber = this.row.property.PropertyOwner.adLicenseNumber;
        this.broker.falLicense = this.row.property.PropertyOwner.falLicense;
        this.broker.agentMobile = this.row.property.PropertyOwner.agentMobile;
        this.agencyDate = this.row.property.PropertyOwner.agencyDate;
        this.baiscAgent.agencyNumber = this.row.property.PropertyOwner.agencyNumber;
        this.baiscAgent.agentDOB = this.row.property.PropertyOwner.agentDOB;
        this.baiscAgent.agentIdentity = this.row.property.PropertyOwner.agentIdentity;
        this.baiscAgent.agentMobile = this.row.property.PropertyOwner.agentMobile;
        this.baiscOwner.ownerDOB = this.row.property.PropertyOwner.ownerDOB;
        this.baiscOwner.ownerIdentity = this.row.property.PropertyOwner.ownerIdentity;
        this.baiscOwner.ownerPhone = this.row.property.PropertyOwner.ownerMobile;
        this.receiptDate = this.row.property.PropertyOwner.receiptDate;
        this.receiptNumber = this.row.property.PropertyOwner.receiptNumber;
        this.receiptImages = this.row.property.PropertyOwner.receiptImage;
        this.agencyImage = this.row.property.PropertyOwner.agencyImage;
        this.propertyAdd.category = this.row.property.category;
        this.propertyAdd.purpose = this.row.property.purpose;
        this.propertyAdd.propertyType = this.row.property.propertyType;
        this.propertyAdd.title = this.row.property.title;
        this.propertyAdd.description = this.row.property.description;
        this.propertyAdd.regionId = this.row.property.Region.id;
        this.citiesList();
        this.propertyAdd.cityId = this.row.property.City.id;
        this.neighborhoodsList();
        this.propertyAdd.neighborhoodId = this.row.property.Neighborhood.id;
        this.propertyAdd.typeId = this.row.property.PropertyType.id;
        this.propertyAdd.area = this.row.property.area;
        this.price = parseFloat(this.row.property.price.replace(',', ''));
        this.mediaList = this.row.property.mediaFiles;
        this.street = this.row.property.street;
        this.buildNumber = this.row.property.buildNumber;
        this.floorNumber = this.row.property.floorNumber;
        this.floorsCount = this.row.property.floorsCount;
        this.apartmentNumber = this.row.property.apartmentNumber;
        this.age = this.row.property.age;
        this.longitude = this.row.property.longitude;
        this.latitude = this.row.property.latitude;
        this.roomsCount = this.row.property.roomsCount;
        this.bathrooms = this.row.property.bathrooms;
        // this.aD_duration.durations = this.row.property.adDuration;
        this.isFeatured = this.row.property.isFeatured;
        // features
        if(this.row.property.PropertyFeatures){
          this.row.property.PropertyFeatures.map(f => {
            this.features.push(f.id);
          });
        }

        this.isLoading = false;
      }).catch(err => {
        // console.log(err);
        this.isLoading = false;
        this.message = this.$globalError(err);
        this.hasError = true;
      });
    },

    submitUpdate() {
      // this.hasError = false;
      this.AdvertisementError = false;
      this.mLoader = true;
      let owner = {
        ownerType: this.ownerType,
        receiptNumber: this.receiptNumber,
        receiptDate: this.receiptDate,
        agencyDate: this.agencyDate,
      };
      let property = {
        ...this.propertyAdd, street: this.street, buildNumber: this.buildNumber, 
        floorsCount: this.floorsCount, floorNumber: this.floorNumber, latitude: this.latitude,
        apartmentNumber: this.apartmentNumber, price: this.price, longitude: this.longitude,
        roomsCount: this.roomsCount, bathrooms: this.bathrooms, age: this.age,
        isFeatured: this.isFeatured, features: this.features, 
        mediaIds: this.mediaIds
      }

      if(this.ownerType == "owner"){
        owner.ownerIdentity = this.baiscOwner.ownerIdentity;
        owner.ownerDOB = this.baiscOwner.ownerDOB;
        owner.ownerMobile = this.baiscOwner.ownerPhone;
      }
      if(this.ownerType == "agent"){
        // owner.ownerIdentity = this.baiscAgent.ownerIdentity;
        // owner.ownerDOB = this.baiscAgent.ownerDOB;
        owner.agentIdentity = this.baiscAgent.agentIdentity;
        // owner.agentDOB = this.baiscAgent.agentDOB;
        owner.agentMobile = this.baiscAgent.agentMobile;
        owner.agencyNumber = this.baiscAgent.agencyNumber;
      }
      if(this.ownerType == "broker"){
        owner.falLicense  = this.broker.falLicense;
        owner.adLicenseNumber = this.broker.adLicenseNumber;
        // owner.ownerDOB  = this.broker.ownerDOB;
        // owner.ownerMobile = this.broker.ownerPhone;
        // owner.agentIdentity = this.broker.agentIdentity;
        // owner.agentDOB = this.broker.agentDOB;
        // owner.agencyNumber = this.broker.agencyNumber;
        owner.agentMobile = this.broker.agentMobile;
      }
      const formData = new FormData();
      formData.append("owner", JSON.stringify(owner));
      formData.append("property", JSON.stringify(property));
      if(this.upReceiptImage){
        for(let i =0; i < this.upReceiptImage.length; i++){
          formData.append("receiptImage", this.upReceiptImage[i]);
        }
      }
      if(this.agencyPhoto){
        for(let file =0; file < this.agencyPhoto.length; file++){
          formData.append("agencyImage", this.agencyPhoto[file]);
        }
      }
      this.$http.put("/api/properties/update/"+this.propertyId,formData).then(res => {
        // console.log(res);
        this.mLoader = false;
        this.form = 5;
      }).catch (err => {
        // console.log(err);
        this.mLoader = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        // this.hasError = true;
        this.AdvertisementError = true;
        window.scroll(0,0);
      })
    },

    async nextStep(){
      if(this.form == 2 && this.ownerType == 'owner'){
        const isValid = await this.V$.baiscOwner.$validate();
        if(!isValid){
          window.scrollTo({top:0, behavior: 'smooth'})
          return false;
        }
      }

      if(this.form == 2 && this.ownerType == 'agent'){
        const isValid = await this.V$.baiscAgent.$validate();
        if(!isValid){
          window.scrollTo({top:0, behavior: 'smooth'})
          return false;
        }
      }

      if(this.form == 3) {
        const isValid = await this.V$.propertyAdd.$validate();
        if(!isValid) {
          window.scrollTo({top:0, behavior: 'smooth'})
          return false;
        }
      }
      // if(this.form == 4) {
      //   const isValid = await this.V$.aD_duration.$validate();
      //   if(!isValid) {
      //     return false;
      //   }
      // }
      if(this.ownerType == "broker" && this.form == "brokerAd") {
        const isValid = await this.V$.broker.$validate();
        if(!isValid) {
          return false;
        }
        this.form = 2;
      }
      
      this.form += 1;
    },

    prevStep(){
      if(this.ownerType == "broker"){
        this.form = 2;
      }
      this.form -= 1;
    },

    ownerFN(){
      this.ownerType = 'owner';
      this.form = 2;
    },

    agentFN(){
      this.ownerType = 'agent';
    },

    restValue() {
      this.features = [];
    },

    uploadFile(files) {
      this.upReceiptImage = [...files];
    },

    uploadAgencyFile(files) {
      this.agencyPhoto = [...files];
    },

    async uploadMedia(files){
      this.mediaLoader = true;
      for(let i=0; i<files.length; i++) {
        const formData = new FormData();
        formData.append('file', files[i]);
        try {
          const mediaFile = await this.$http.post("/api/media/upload",formData);
          if(mediaFile) {
            this.mediaIds.push(mediaFile.data.mediaId);
            this.mediaList.push({
              id: mediaFile.data.mediaId,
              thumbnail: mediaFile.data.filePath,
            })
          }
        } catch (err){
          // console.log(err);
          this.mediaLoader = false;
          this.message = this.$globalError(err);
          this.hasError = true;
        }finally {
          this.mediaLoader = false;
        }
      }
    },

    citiesList(){
      this.hasError = false;
      this.$http.get(`/api/cities/list/?regionId=${this.propertyAdd.regionId}`).then(res => {
        // console.log(res);
        this.cities = res.data.cities;
      }).catch (err => {
        // console.log(err);
        this.message = this.$globalError(err);
        this.hasError = true;
      })
    },

    neighborhoodsList(){
      this.hasError = false;
      this.$http.get(`/api/neighborhoods/list/?cityId=${this.propertyAdd.cityId}`).then(res => {
        // console.log(res);
        this.rows = res.data.neighborhoods;
      }).catch(err => {
        // console.log(err);
        this.message = this.$globalError(err);
        this.hasError = true;
      })
    },

    brokerAdvertisement(){
      this.form = 'brokerAd';
      this.ownerType = "broker" ;
    },

    deleteImg(id, indx){
      swal({
        title: this.$t('image_Title'),
        // text: "You will not be able to recover this imaginary file!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: this.$t('confirmButtonText'),
        cancelButtonText: this.$t('cancelButtonText'),
        closeOnConfirm: false
      },()=> this.deleteMedia(id, indx));
    },
    
    deleteMedia(id, indx){
      this.$http.delete("/api/media/delete/"+id).then(res => {
        this.mediaList.splice(indx, 1);
        this.mediaIds.splice(indx, 1);
        swal(this.$t('success_Message'));
      })
    },

    //function get Location user
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.longitude = position.coords.longitude;
            this.latitude = position.coords.latitude;
            this.getDatainit();
          },
          (err) => {
            // this.error = `Error: ${err.message}`;
            // this.getData();
          }
        );
      } else {
        // this.error = "Geolocation is not supported by this browser.";
        // this.getData();
      }
    },
    initMap(){
      if (!this.$refs.myMap) {
        setTimeout(() => this.initMap(), 200);
        return;
      }
      if (!window.google) {
        console.error("Google Maps API is not loaded.");
        return;
      }
      // Initialize Map
      
      this.map = new google.maps.Map(this.$refs.myMap, {
        center: { 
          lat: (this.latitude) ? parseFloat(this.latitude) :24.7136, 
          lng: (this.longitude) ? parseFloat(this.longitude) : 46.6753, 
        },
        zoom: 8,
      });
      
      // Create a Marker
      this.marker = new google.maps.Marker({
        position: { 
          lat: (this.latitude)? parseFloat(this.latitude) : 24.7136, 
          lng: (this.longitude) ? parseFloat(this.longitude) : 46.6753 
        },
        map: this.map,
        draggable: true, // Allow dragging the marker
      });

      // Update lat/lng when marker is moved
      this.marker.addListener("dragend", () => {
        const pos = this.marker.getPosition();
        this.latitude = pos.lat();
        this.longitude = pos.lng();
      });

      // Click on the map to set a new marker position
      this.map.addListener("click", (event) => {
        this.latitude = event.latLng.lat();
        this.longitude = event.latLng.lng();
        this.marker.setPosition(event.latLng);
      });
    },
    initialGoogleMap(){
      if (!window.google) {
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCmKIguViZj4DtgCcT2Wv8pstx0ynuHMWg&loading=async&libraries=places&callback=initMap`
        script.async = true;
        document.head.appendChild(script);
        window.initMap = this.initMap;
      } else {
        this.initMap();
      }
    },
  },
  created(){
    this.getDatainit();
    this.retrieveData();
    this.userLang = localStorage.getItem('lang') ?? 'ar';
  }
}
</script>